import axiosInstance from "../interceptor/intercetptor-inctence";

export const logOutUser = (formData) => {
    return axiosInstance.post(`api/lab-user/logout`, formData);
}